import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const cabs = [
  {
    id: 1,
    image: '/images/ourfleet/1.jpg',
    name: 'Swift Dzire',
    location: 'Delhi',
    doors: 4,
    passengers: 4,
    luggage: 2,
    ac: 'Yes',
    gps: 'Yes',
    price: '59',
    oldPrice: '79',
    rating: '4.8'
  },
  {
    id: 2,
    image: '/images/ourfleet/2.jpg',
    name: 'Ertiga',
    location: 'Delhi',
    doors: 4,
    passengers: 6,
    luggage: 2,
    ac: 'Yes',
    gps: 'Yes',
    price: '65',
    oldPrice: '85',
    rating: '4.7'
  },
  {
    id: 3,
    image: '/images/ourfleet/8.jpg',
    name: 'Aura',
    location: 'Delhi',
    doors: 4,
    passengers: 4,
    luggage: 2,
    ac: 'Yes',
    gps: 'Yes',
    price: '62',
    oldPrice: '82',
    rating: '4.9'
  },
];

const PopularCabs = () => {
  return (
    <section className="py-5 bg-choose">
      <div className="container">
        <div className="text-center mb-5">
          <h2>Popular Cabs</h2>
          <p className='text-dark'>Choose from our most trusted and comfortable vehicles</p>
        </div>

        <div className="row g-4">
          {cabs.map(cab => (
            <div className="col-md-4" key={cab.id}>
              <div className="card shadow-sm h-100 border-0">
                <img src={cab.image} className="card-img-top borderr" alt={cab.name} />
                <div className="card-body">
                  <h5 className="card-title">{cab.name}</h5>
                  <ul className="list-unstyled small mb-4">
                    <li className="mb-2 d-flex justify-content-between">
                      <span><i className="fa-solid fa-door-open me-2 text-primaryy"></i>Taxi Doors</span>
                      <span>{cab.doors}</span>
                    </li>
                    <li className="mb-2 d-flex justify-content-between">
                      <span><i className="fa-solid fa-user-group me-2 text-primaryy"></i>Passengers</span>
                      <span>{cab.passengers}</span>
                    </li>
                    <li className="mb-2 d-flex justify-content-between">
                      <span><i className="fa-solid fa-suitcase-rolling me-2 text-primaryy"></i>Luggage Carry</span>
                      <span>{cab.luggage}</span>
                    </li>
                    <li className="mb-2 d-flex justify-content-between">
                      <span><i className="fa-solid fa-snowflake me-2 text-primaryy"></i>Air Condition</span>
                      <span>{cab.ac}</span>
                    </li>
                    <li className="mb-2 d-flex justify-content-between">
                      <span><i className="fa-solid fa-location-dot me-2 text-primaryy"></i>GPS Navigation</span>
                      <span>{cab.gps}</span>
                    </li>
                  </ul>

                  <a href="/booking" className="btn btn-outline-primary w-100 mt-2">
                    Book Taxi Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularCabs;
